export enum AdyenPaymentError {
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  EXPIRED_CARD = 'EXPIRED_CARD',
  INVALID_CARD_NUMBER = 'INVALID_CARD_NUMBER',
  INVALID_CVC = 'INVALID_CVC',
  REFUSED = 'REFUSED',
  BLOCKED_CARD = 'BLOCKED_CARD',
  FRAUD_SUSPECTED = 'FRAUD_SUSPECTED',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  THREE_DS_FAILED = '3DS_FAILED',
}
